import React from 'react';
import styles from './Tabs.module.scss';

export default function Tabs(props) {
    return (
        <section className={styles.Tabs}>
            {props.children}
        </section>
    );
}